import { ReactNode } from 'react';
import { createPortal } from 'react-dom';

import { useMounted } from './lifecycle/mount';

interface PortalProps {
  selector: string;
  children: ReactNode;
}

export const Portal = ({ selector, children }: PortalProps) => {
  const isMounted = useMounted();

  if (!isMounted) return null;

  const el = document.querySelector(selector);
  if (!el) throw new Error(`No element of '${selector}'`);

  return createPortal(children, el);
};
